import { Button, Description, DescriptionItem, Notification, Spacer, Text } from '@app/components'
import { IStore } from '@app/redux'
import { auth, errorHandler } from '@app/services'
import { WithdrawSummaryProps } from '@app/types'
import { toCurrency } from '@app/utils'
import axios from 'axios'
import { AddDiscountDrawer } from 'collections/buy-and-sell/drawers'
import React, { useState } from 'react'
import { useSelector } from 'react-redux'

import { StyledCard } from './elements'

export const WithdrawSummary: React.FC<WithdrawSummaryProps> = ({
  method,
  purchaseData: { pay, receive },
  refresh,
  selectedPanel,
}) => {
  const [loading, setLoading] = useState(false)
  const [discountDrawerOpen, setDiscountDrawerOpen] = useState(false)

  const handleClick = async () => {
    // if (selectedPanel == '1') {
    //   onWireSubmit()
    // } else {
    transfer()
    //}
    pay.setAmount(0)
    receive.setAmount(0)
  }

  const { user } = useSelector((state: IStore) => state)

  const transfer = async () => {
    try {
      setLoading(true)

      const data = {
        entityId: user.selectedEntityName ? user.selectedEntityIdentityId : null,
        id: method.id,
        amount: pay.amount,
        receive: receive.amount,
        type: selectedPanel,
      }

      const authorization = await auth.currentUser.getIdToken()
      const headers = {
        Authorization: authorization,
      }
      await axios.post('/api/north-one/withdraw', data, { headers })

      Notification({ message: 'Transaction completed successfully', type: 'success' })
      setLoading(false)
      refresh()
    } catch (error) {
      Notification({ message: error.message, type: 'error' })
      errorHandler.report`Failed to submit ach push: ${error}`
      setLoading(false)
    }
  }

  const topLabelItemStyle: React.CSSProperties = {
    fontSize: '18px',
    fontWeight: 'bold',
  }

  const topDescriptionItemStyle: React.CSSProperties = {
    justifyContent: 'end',
    fontSize: '18px',
  }

  const descriptionItemStyle: React.CSSProperties = {
    justifyContent: 'end',
  }

  const labelFeeBoldItemStyle: React.CSSProperties = {
    marginLeft: '16px',
    fontSize: '14px',
  }

  const descFeeBoldItemStyle: React.CSSProperties = {
    justifyContent: 'end',
    fontSize: '14px',
  }

  const summaryDesc = <Text style={{ fontSize: '24px' }}>Withdraw Summary</Text>

  return (
    <>
      <StyledCard>
        <Description title={summaryDesc} column={1}>
          <DescriptionItem
            label={'Total Withdraw'}
            labelStyle={topLabelItemStyle}
            contentStyle={topDescriptionItemStyle}
          >
            {`${toCurrency(pay.amount, true)} ${pay.type}`}
          </DescriptionItem>
          <DescriptionItem
            label={'Total Recieved'}
            labelStyle={topLabelItemStyle}
            contentStyle={topDescriptionItemStyle}
          >
            {`${toCurrency(receive.amount, true)} ${receive.type}`}
          </DescriptionItem>
          <DescriptionItem label={'Total Fees'} contentStyle={descriptionItemStyle}>
            {`${toCurrency(pay.amount - receive.amount, true)} ${receive.type}`}
          </DescriptionItem>
          <DescriptionItem
            label={'Withdraw Fee'}
            labelStyle={labelFeeBoldItemStyle}
            contentStyle={descFeeBoldItemStyle}
          >
            {`${toCurrency(selectedPanel == 4 || selectedPanel == 2 ? 0 : pay.amount * 0.0025, true)} ${receive.type}`}
          </DescriptionItem>
          <DescriptionItem
            label={`${
              selectedPanel == 6
                ? 'Zelle'
                : selectedPanel == 1
                  ? 'Wire'
                  : selectedPanel == 3
                    ? 'ACH'
                    : selectedPanel == 7
                      ? 'ACH'
                      : selectedPanel == 5
                        ? 'Local'
                        : 'OGB'
            } Fee`}
            labelStyle={labelFeeBoldItemStyle}
            contentStyle={descFeeBoldItemStyle}
          >
            {`${toCurrency(
              selectedPanel == 4 || selectedPanel == 2 ? 0 : pay.amount - receive.amount - pay.amount * 0.0025,
              true,
            )} ${receive.type}`}
          </DescriptionItem>
          <DescriptionItem label={'Withdraw Method'} contentStyle={descriptionItemStyle}>
            {selectedPanel == 6
              ? 'Zelle'
              : selectedPanel == 1
                ? 'Wire'
                : selectedPanel == 3
                  ? 'ACH'
                  : selectedPanel == 7
                    ? 'ACH'
                    : selectedPanel == 5
                      ? 'Local'
                      : 'OGB'}
          </DescriptionItem>
        </Description>
        <Spacer />
        <Button
          block
          disabled={
            !pay.amount ||
            receive.amount <= 0 ||
            loading ||
            (selectedPanel == 6
              ? method.name == ''
                ? true
                : false
              : selectedPanel == 1
                ? method.name == ''
                  ? true
                  : false
                : selectedPanel == 3
                  ? method.name == ''
                    ? true
                    : false
                  : selectedPanel == 2
                    ? method.name == ''
                      ? true
                      : false
                    : selectedPanel == 4
                      ? method.name == ''
                        ? true
                        : false
                      : selectedPanel == 5
                        ? method.name == ''
                          ? true
                          : false
                        : selectedPanel == 7
                          ? method.name == ''
                            ? true
                            : false
                          : true) ||
            (selectedPanel == 2 ? pay.amount > 5000 : false) ||
            (selectedPanel == 4 ? pay.amount > 10000 : false)
          }
          onClick={handleClick}
          loading={loading}
        >
          {selectedPanel == 2 && pay.amount > 5000
            ? 'Exceeded $5,000 limit'
            : `Withdraw ${toCurrency(receive.amount, false)} ${pay.type}`}
        </Button>
      </StyledCard>
      <AddDiscountDrawer open={discountDrawerOpen} toggleOpen={() => setDiscountDrawerOpen(!discountDrawerOpen)} />
    </>
  )
}
